"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcABV = exports.estABV = exports.estABW = void 0;
const utils_1 = require("./utils");
const units_1 = require("./units");
// http://byo.com/bock/item/408-calculating-alcohol-content-attenuation-extract-and-calories-advanced-homebrewing
// https://www.brewersfriend.com/2011/06/16/alcohol-by-volume-calculator-updated/
// ABW = (OG points - FG points) * 0.105
// ABV = (OG points - FG points) * 0.132
const estABW = (ogPts, fgPts) => (ogPts - fgPts) * 0.105;
exports.estABW = estABW;
const estABV = (ogPts, fgPts) => (ogPts - fgPts) * 0.132;
exports.estABV = estABV;
// http://beersmith.com/blog/2010/09/07/apparent-and-real-attenuation-for-beer-brewers-part-1/
const estABVrealExtract = (og, fg) => {
    const oe = utils_1.sgToPlato(og);
    const ae = utils_1.sgToPlato(fg);
    const re = 0.1808 * oe + 0.8192 * ae;
    const abw = (oe - re) / (2.0665 - 0.010665 * oe);
    const abv = abw * (fg / 0.79661);
    return abv;
};
const calcABV = (og, fg) => {
    return {
        value: estABVrealExtract(units_1.convertMeasurableValue(og, 'sg'), units_1.convertMeasurableValue(fg, 'sg')),
        unit: '%',
    };
};
exports.calcABV = calcABV;
//# sourceMappingURL=abv.js.map